import { useQuery } from "@tanstack/react-query";

import { usePrivateAxios } from "./use-private-axios";

export function usePaymentMethods() {
	const axios = usePrivateAxios();
	return useQuery({
		queryKey: ["payment-methods"],
		queryFn: () => {
			return axios.get("/paymentOption");
		}
	});
}
